<template lang='pug'>
  .product-promo(:class='{ "short": short }')
    template(v-if='showPromo(variantId)')
      i.product-promo-tag(:class='{ "virtual-bundle": isVirtualBundleAd }')
      span.product-promo-title(v-text='promoTitle')
      a.text-link(
        v-if='showDetails'
        href='#product-promo-details'
        :data-title='ad.attributes["title"]'
        data-toggle='modal'
        v-t='"common.details"'
      )
      .option-type-text(v-if='optionType.length > 0' v-t='{ path: "selectedTypeOnly", args: { optionType: optionType.toLowerCase() } }')

    .modal.fade#product-promo-details(v-if='ad && !short' aria-hidden='true' role='dialog' tabindex='-1')
      .modal-dialog(role='document')
        .modal-content
          .modal-header
            .modal-title
              h3.h3(v-text='ad.attributes["title"]')
            button.close(type='button' data-dismiss='modal' aria-label='Close')
          .modal-body.product-promo-terms
            p(v-html='ad.attributes["terms"]')
</template>

<i18n>
{
  "lng_en": {
    "selectedTypeOnly": "Selected %{optionType}s only"
  },
  "lng_id": {
    "selectedTypeOnly": "Selected %{optionType}s only"
  },
  "lng_th": {
    "selectedTypeOnly": "Selected %{optionType}s only"
  },
  "lng_zh": {
    "selectedTypeOnly": "Selected %{optionType}s only"
  },
  "lng_ko": {
    "selectedTypeOnly": "선택한 %{optionType}에 한함"
  }
}
</i18n>

<script>
import { adUtil } from '@/mixins/adUtil.js'
import get from 'lodash/get'

export default {

  mixins: [
    adUtil
  ],
  props: {
    ad: {
      type: Object,
      default: () => {}
    },
    short: {
      type: Boolean,
      default: false
    },
    variantId: {
      type: Number,
      default: 0
    },
    optionType: {
      type: String,
      default: ''
    }
  },

  computed: {
    promoTitle () {
      return this.short ? this.ad.attributes['short-title'] : this.ad.attributes['title']
    },
    showDetails () {
      return !this.short && this.ad.attributes['terms']
    }
  },

  methods: {
    showPromo (variantId) {
      const ad = get(this.ad, 'attributes["product-variant-ids"]')
      if (this.short && ad) {
        return ad.indexOf(variantId) !== -1
      } else if (this.ad) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang='scss'>
  .product-promo-terms {
    li {
      list-style: disc;
      margin-left: 15px;
    }
  }

  .product-card { // shift heart if promo present
    .product-card-heart, .product-card-heart-filled {
      @include media-breakpoint-up(xl) {
        top: 31px;
      }
    }
  }
</style>

<style scoped lang='scss'>
  .product-promo {
    min-height: 31px;

    @include media-breakpoint-down(sm) {
      margin-bottom: 10px;
    }

    &.short {
      font-size: 11px;
      margin-bottom: 0;

      @include media-breakpoint-up(sm) {
        font-size: 14px;

        .product-promo-tag {
          margin-right: 5px;

          &.virtual-bundle {
            margin-right: 2px;
          }
        }
      }

      @include media-breakpoint-up(md) {
        font-size: 15px;
      }
    }

    .modal-body {
      line-height: 16px;
    }
  }

  .option-type-text {
    font-size: 10px;
    margin-top: -5px;
    line-height: 12px;

    @include media-breakpoint-up(sm) {
      font-size: 12px;
      line-height: inherit;
    }

    @include media-breakpoint-up(md) {
      font-size: 11px;
      margin-top: -1px;
    }
  }

  .product-promo-tag {
    background-image: url('../../assets/images/icons/promo-tag.svg');
    display: inline-block;
    vertical-align: middle;
    margin-top: -3px;
    margin-right: 2px;
    height: 9px;
    width: 13px;

    @include media-breakpoint-up(sm) {
      margin-right: 8px;
      height: 10px;
      width: 15px;
    }

    @include media-breakpoint-up(md) {
      height: 12px;
      width: 18px;
    }

    &.virtual-bundle {
      height: 20px;
      width: 18px;
      background-image: url('../../assets/images/icons/virtual-bundle-tag.svg');
    }
  }

  .product-promo-title {
    @include font-weight-medium;
    margin-right: 5px;
    margin-left: 2px;
  }

  .text-link {
    border-bottom: 1px solid $black;

    &:hover {
      border-bottom: 1px solid $brand-primary;
    }
  }
</style>
